import URLS from './url-referrer.js';

const DEFAULT_VALUE = '(not set)';
const UTM_SOURCE = 'utm_source';
const UTM_MEDIUM = 'utm_medium';
const UTM_CAMPAIGN = 'utm_campaign';
const UTM_TERM = 'utm_term';
const UTM_CONTENT = 'utm_content';
const getUtmCampaign = params => params.get(UTM_CAMPAIGN) || DEFAULT_VALUE;
const getUtmTerm = params => params.get(UTM_TERM) || DEFAULT_VALUE;
const getUtmContent = params => params.get(UTM_CONTENT) || DEFAULT_VALUE;
const getFromUrl = params => {
  const refererSource = params.get(UTM_SOURCE);
  const refererMedium = params.get(UTM_MEDIUM);
  if (refererSource && refererMedium) {
    return {
      refererSource,
      refererMedium,
      refererCampaign: getUtmCampaign(params),
      refererTerm: getUtmTerm(params),
      refererContent: getUtmContent(params)
    };
  }
  return null;
};
const getFromGclid = params => {
  const gclid = params.get('gclid');
  if (gclid) {
    return {
      refererSource: 'google',
      refererMedium: 'cpc',
      refererCampaign: getUtmCampaign(params),
      refererTerm: getUtmTerm(params),
      refererContent: getUtmContent(params)
    };
  }
  return null;
};
const getUtmReferrer = ({
  urlReferrer,
  refererMedium
}) => {
  const {
    cname,
    domain: refererSource,
    ending: refererCampaign
  } = URLS.getDomainData(urlReferrer);
  return {
    refererSource: refererSource || DEFAULT_VALUE,
    refererMedium: refererMedium || DEFAULT_VALUE,
    refererCampaign: refererCampaign || DEFAULT_VALUE,
    refererTerm: DEFAULT_VALUE,
    refererContent: cname || DEFAULT_VALUE
  };
};
const getFromUtmReferrer = (urlReferrer, isReferrerTheCurrentLocation) => {
  if (!urlReferrer || isReferrerTheCurrentLocation) return null;
  if (URLS.matchesSearchEngine(urlReferrer)) return getUtmReferrer({
    urlReferrer,
    refererMedium: 'organic'
  });
  if (URLS.matchesSocialNetwroks(urlReferrer)) return getUtmReferrer({
    urlReferrer,
    refererMedium: 'social'
  });
  return getUtmReferrer({
    urlReferrer,
    refererMedium: 'referral'
  });
};
const getFromDocumentReferrer = ({
  referrer,
  previousUtmValues,
  isReferrerTheCurrentLocation
}) => {
  if (referrer && !isReferrerTheCurrentLocation) return getFromUtmReferrer(referrer);
  if (previousUtmValues) return previousUtmValues;
  return {
    refererSource: DEFAULT_VALUE,
    refererMedium: 'direct',
    refererCampaign: DEFAULT_VALUE,
    refererTerm: DEFAULT_VALUE,
    refererContent: DEFAULT_VALUE
  };
};
const getUtmAttributes = ({
  location: {
    search = '',
    host
  } = {},
  document: {
    referrer
  } = {},
  previousUtmValues
}) => {
  const isReferrerTheCurrentLocation = referrer && host && referrer.includes(host);
  if (isReferrerTheCurrentLocation && previousUtmValues) return previousUtmValues;
  const params = new URLSearchParams(search);
  const URL_UTM = getFromUrl(params);
  if (URL_UTM) return URL_UTM;
  const GCLID_UTM = getFromGclid(params);
  if (GCLID_UTM) return GCLID_UTM;
  const URL_REFERRER_UTM = getFromUtmReferrer(params.get('utm_referrer'), isReferrerTheCurrentLocation);
  if (URL_REFERRER_UTM) return URL_REFERRER_UTM;
  return getFromDocumentReferrer({
    referrer,
    previousUtmValues,
    isReferrerTheCurrentLocation
  });
};
var trafficSource = getUtmAttributes;

export { trafficSource as default };
